import React, {useEffect} from 'react';
import { usePrecalculationContext } from './context';
import { Heading4 } from '../../../../libs/uiKit/globalStyledComponents';
import { FieldsBuilder } from '../../../../libs/uiKit/fieldsBuilder';
import HouseInProgress from './HouseInProgress';
import {AddIcon} from "../../../../icons/ui/Add";
import Button from "../../../../libs/uiKit/button";
import {TrashIcon} from "../../../../icons/ui/Trash";
import { StyledSubjectHeader } from './styles';
import useGetDicti from "../../common/hooks/useGetDicti";
import {DictKeyEnum} from "../../../../libs/api/graphqlTypes";
import {CROSSSALE_HELP, PROPERTY_FLAT} from "../../../../libs/utils/staticData";
import {useGlobalContext} from "../../../../apps/main/ui/GlobalContext";
import useNotification from "../../../widgets/notifier/ui/hooks/useNitification";

const Risks: React.FC<{ riskType: 'life' | 'title' | 'property' }> = ({ riskType }) => {
	const { propertyItems, titleForm, propAppend, propRemove, formHook, bankItems } = usePrecalculationContext();

	const propWatch = formHook.watch(`properties`);
	const [crossRisks, crossInterior, crossResponsibility] = formHook.watch([`crossRisks`, 'crossInterior', 'crossResponsibility']);

	const {
		user: { crossEnabled, isStaffMember },
	} = useGlobalContext();

	const { setNotification } = useNotification();

	useEffect(() => {
		console.log('propWatch', propWatch);
	}, [propWatch]);

	useEffect(() => {
		if(!crossInterior){
			formHook.setValue('crossProperty', null);
		}
	}, [crossInterior]);

	const { data: propertySums, loading: loadingPropertySums } = useGetDicti(DictKeyEnum.CrosssaleProperty);
	const { data: propertyInteriors, loading: loadingPropertyInteriors } = useGetDicti(DictKeyEnum.CrossaleInterior);
	const { data: propertyResponsibilities, loading: loadingPropertyResponsibilities } = useGetDicti(DictKeyEnum.CrossaleResponsibility);

	const getPropertyItemTitle = (itemsCount: number, propertyType: string|undefined, ) => {
		return (itemsCount > 1 && propertyType) ? propertyType : "Имущество";
	}

	switch (riskType) {
		case 'life':
			return (
				<>
					<Heading4 style={{marginBottom: '0'}}>Заёмщик</Heading4>
					<HouseInProgress />
				</>
			);
		case 'property':
			return (
				<>
					{
						propertyItems.map((item, index) => {
							const title = propWatch ? (propWatch[index].objectType?.label + (propWatch.filter((prop: any, i: number) => prop?.objectType?.label === propWatch[index].objectType?.label && i < index).length ? ` ${index + 1}` : '')) : '';
							return (
								<React.Fragment key={`property-${index}`}>
									<StyledSubjectHeader>
										<Heading4>{getPropertyItemTitle(propertyItems?.length || 1, item.title)}</Heading4>
										{propertyItems.length > 1 &&
											<Button appearance='icon' onClick={(): void => propRemove(index)}
													icon={<TrashIcon/>}/>
										}
									</StyledSubjectHeader>
									<FieldsBuilder {...item.form} />
									{index === 0 &&
										<FieldsBuilder fields={[
											{
												isHidden: !crossEnabled
                                                    || propWatch && propWatch[0]?.objectType?.value && propWatch[0]?.objectType?.value !== PROPERTY_FLAT
                                                    || propWatch && propWatch[0]?.objectBuildYear && propWatch[0]?.objectBuildYear < 1950
                                                    || propWatch && propWatch[0]?.woodInConstruction
                                                    || bankItems.length > 1,
												field: {
													fieldType: 'checkbox',
													fieldName: `crossRisks`,
													label: 'Застраховать дополнительные риски',
													helpMessage: CROSSSALE_HELP
												},
											},
											{
												isHidden: !crossRisks,
												field: {
													fieldName: "crossInterior",
													fieldType: "select",
													isLoading: loadingPropertyInteriors,
													errorMessage: "Выберите сумму",
													placeholder: "Внутренняя отделка, ₽",
													items: propertyInteriors,
													isClearable: true,
                                                    grid: 12,
                                                    pseudoGrid: 6,
												}
											},
											{
												isHidden: !crossRisks,
												field: {
													fieldName: "crossResponsibility",
													fieldType: "select",
													isLoading: loadingPropertyResponsibilities,
													errorMessage: "Укажите сумму",
													placeholder: "Гражданская ответственность, ₽",
													items: propertyResponsibilities,
													isClearable: true,
                                                    grid: 12,
                                                    pseudoGrid: 6,
												}
											},
											{
												isHidden: !crossRisks,
												field: {
													fieldName: "crossProperty",
													fieldType: "select",
													isLoading: loadingPropertySums,
													errorMessage: "Укажите сумму",
													placeholder: "Движимое имущество, ₽",
													items: propertySums,
													isClearable: true,
													isDisabled: !crossInterior,
                                                    grid: 12,
                                                    pseudoGrid: 6,
												}
											},
										]} formHook={formHook} />
									}
								</React.Fragment>
							);
						})
					}
					{propertyItems.length < 5 &&
						<Button appearance='lightblue'
						        style={{width: '24rem', marginTop: '2rem'}}
								onClick={() => {
									if(propertyItems.length === 3){
										return setNotification({
											type: 'error',
											text: isStaffMember
												? 'Превышено максимальное количество объектов, доступных к оформлению в B2B. Оформление договора возможно в КИАС'
												: 'Превышено максимальное количество объектов, доступных к оформлению в B2B. Для оформления договора обратитесь к куратору'
										});
									}
									propAppend({})
								}}>
							Добавить имущество
						</Button>
					}

				</>
			);
		case 'title':
			return (
				<>
					<Heading4>Титул</Heading4>
					<FieldsBuilder {...titleForm} />
				</>
			);
		default:
			return null;
	}
};

export default Risks;
